var _defs, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgProcessPayment = function SvgProcessPayment(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 74 74",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#d7dadb;}.b{fill:#707070;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -0.439)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 37,
    cy: 37,
    r: 37,
    transform: "translate(0 0.439)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(24.92 28.439)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M23.294,4H4.366A2.348,2.348,0,0,0,2.012,6.366L2,20.562a2.358,2.358,0,0,0,2.366,2.366H23.294a2.358,2.358,0,0,0,2.366-2.366V6.366A2.358,2.358,0,0,0,23.294,4Zm0,16.562H4.366v-7.1H23.294Zm0-11.83H4.366V6.366H23.294Z",
    transform: "translate(-2 -4)"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgProcessPayment, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/process_payment.c356e361.svg";
export { ForwardRef as ReactComponent };